import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    marginTop: '30px'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    gap: 30,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr 1fr 1fr'
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr 1fr'
    },
    marginTop: 8
  },
  footer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '32px'
  },
  icon: {
    transform: 'rotate(180deg)'
  },
  buttonText: {
    color: theme.palette.primary.main,
    fontWeight: 500
  }
}))

export default useStyles
